export enum CoverageAttachmentStrategy {
  CheckOut = "check_out",
  Checkbox = "checkbox",
  DoubleCheckOut = "double_check_out",
  DoubleToggle = "double_toggle",
  DropDown = "drop_down",
  SingleToggle = "single_toggle",
  CartCard = "cart_card",
  CheckoutButtonProduct = "checkout_button_product",
  CheckoutButtonShipping = "checkout_button_shipping",
  Shipping = "shipping",
  ToggleCustomCheckoutFee = "toggle_custom_checkout_fee",
  AnyWidgetCustomFee = "any_widget_custom_fee",
  AnyWidgetProduct = "any_widget_product",
  None = "none",
}
